export const typePolicies = {
	Query: {
		fields: {
			merchantMe: {
				merge(existing = {}, incoming) {
					return {
						...existing,
						...incoming,
					}
				},
			},
		},
	},
	MerchantStatistics: {
		keyFields: ['merchantID'],
		merge: true,
	},
	Offer: {
		fields: {
			statistics: {
				merge(existing, incoming, { mergeObjects }) {
					return mergeObjects(existing, incoming)
				},
			},
		},
	},
	OfferStatistics: {
		merge: true,
	},
	Classification: {
		keyFields: ['name'],
	},
	MerchantPermission: {
		keyFields: ['target'],
	},
	Permission: {
		keyFields: ['target'],
	},
	User: {
		fields: {
			permissions: {
				keyArgs: ['types'],
			},
		},
	},
}
